import React from 'react'

import { FormField, Autosuggest} from '@cloudscape-design/components'

export type ComboInputProps = {
    label: string,
    value: string, 
    options: string | Array<any>,
    onChange: (value: string) => void, 
    validate?: (value: string, label: string) => boolean,
    readOnly: boolean, 
    [rest: string]: any,
}

export default function ComboInput({ label, value, options, onChange, validate, readOnly, ...rest }: ComboInputProps) {
    const strings = (typeof options === 'string') ? options.split(';') : options    
    const valid = (!readOnly && validate) ? validate(value, label) : true

    return (
        <FormField label={label} info={validate || readOnly ? '' : 'Optional'} >
            <Autosuggest readOnly={readOnly}
                value={value ?? ''}
                options={strings.map((option: string) => ({value: option, label: option}))}
                onChange={ e => onChange(e.detail.value) }
                invalid={!readOnly && !valid}
                {...rest}
            />
        </FormField> 
    )
}